import { Button, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';

type AddButtonProps = {
  onClick: () => void;
};

const AddButton: FC<AddButtonProps> = ({ onClick, children }) => {
  const handleClick = () => {
    onClick();
  };
  return (
    <>
      <Button
        display="flex"
        alignItems="center"
        size="sm"
        variant="outline"
        colorScheme="cyan"
        onClick={handleClick}
      >
        <AiOutlinePlusCircle />
        <Text ml="1.5">{children}</Text>
      </Button>
    </>
  );
};

export default AddButton;
